const BarChartItemModel = {
  position: 1,
  value: 0,
  color: '',
  label: { pl: '', en: '' },
};

export default BarChartItemModel;
